import EvolutionChamber from "@/views/pokeevo/EvolutionChamber.vue";

export default [
  {
    path: "/evolutionchamber",  
    name: "EvolutionChamber",
    component: EvolutionChamber,
  },
];
